import React, { useState } from "react";
// import { toast } from 'react-toastify';
import HashLoader from "react-spinners/HashLoader";
// import { useWeb3React } from "@web3-react/core";
import { Link } from "react-router-dom";
import { useMyTokenLockStats } from "./helper/useStats";
import { useNetwork } from "wagmi";

export default function TokenLockList() {
  const [updater, setUpdater] = useState({
    page: 0,
    pageSize: 10,
    loading: true,
  });
  const stats = useMyTokenLockStats(updater);
  const chain = useNetwork();

  const host = window.location.host;
  const protocol = window.location.protocol;
  const explorerLink = `${protocol}//${host}/lock-details/`;

  function handleClick(location) {
    window.location.href = explorerLink + location;
  }

  return (
    <div className="container">
      <React.Fragment>
        <section className="explore-area prev-project-area">
          <div className="intro">
            <div className="text-center intro-content">
              <span className="intro-text">My Locked Token List</span>
            </div>
            <div
              className="flex-wrap pl-3 mt-5 explore-menu btn-group btn-group-toggle"
              data-toggle="buttons"
            >
              <label className="p-2 btn d-table text-uppercase">
                <Link to="/token-locked" className="explore-btn">
                  <span>Token Lock List</span>
                </Link>
              </label>
              <label className="p-2 btn active d-table text-uppercase">
                <Link to="/my-token-lock" className="explore-btn">
                  <span>My Token Lock List</span>
                </Link>
              </label>
            </div>
          </div>

          <section className="pt-2 card leaderboard-area">
            <div className="row">
              <div className="col-12">
                <div className="table-responsive">
                  <table className="table table-borderless">
                    <thead>
                      <tr>
                        <th scope="col">No</th>
                        <th scope="col">Name</th>
                        <th scope="col">Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {stats.loading ? (
                        <div className="row">
                          <div className="col-12 d-flex justify-content-between">
                            <HashLoader
                              size="100"
                              color="#fff"
                              cssOverride={{ left: "50%", top: "20%" }}
                            />
                          </div>
                        </div>
                      ) : stats.tokenList.length > 0 ? (
                        stats.tokenList
                          .slice(0)
                          .reverse()
                          .map((rowdata, index) => {
                            return (
                              <tr key={index} onClick={() => handleClick(rowdata.token)} style={{ cursor: "pointer" }}>
                                <td>
                                  {stats.page > 0
                                    ? stats.page * stats.pageSize + 1 + index
                                    : index + 1}
                                </td>
                                <td className="image-row">
                                  {" "}
                                  {rowdata.name} ~ {rowdata.symbol}
                                </td>
                                <td>
                                  {rowdata.amount
                                    ? rowdata.amount /
                                      Math.pow(10, rowdata.decimals)
                                    : "0"}{" "}
                                  {rowdata.symbol}
                                </td>
                              </tr>
                            );
                          })
                      ) : (
                        <tr className="mt-4 text-center">
                          <td
                            style={{ backgroundColor: "transparent" }}
                            colSpan="4"
                          >
                            No Lock Record Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="mt-3 row">
              <div className="col-12">
                <nav>
                  <ul className="page-numbers">
                    <li>
                      {stats.page > 0 && (
                        <a
                          href="#sec"
                          onClick={(e) =>
                            setUpdater({
                              page: stats.page - 1,
                              pageSize: stats.pageSize,
                              loading: true,
                            })
                          }
                        >
                          <i className="mr-2 icon-Vector"></i>Previous
                        </a>
                      )}
                    </li>
                    {Math.floor(
                      stats.allNormalTokenLockedCount / stats.pageSize
                    ) > parseFloat(stats.page) && (
                      <li>
                        <a
                          href="#sec"
                          onClick={(e) =>
                            setUpdater({
                              page: stats.page + 1,
                              pageSize: stats.pageSize,
                              loading: true,
                            })
                          }
                        >
                          Next<i className="ml-2 icon-arrow_right"></i>
                        </a>
                      </li>
                    )}
                  </ul>
                </nav>
              </div>
            </div>
          </section>
        </section>
      </React.Fragment>
    </div>
  );
}
